import { getCategoriesNgos } from 'utilities/formatNgosList';

    const getSearchedNGOs = (e, defaultCategoriesList, ngosList, handleShowDetailNgo, environmentConfig, selected)  => {
    const inputValue = e.currentTarget.value
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    if (inputValue.length === 0) {
       return defaultCategoriesList
    }
    const filteredValues = ngosList.filter(element => {
      return element.name
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .includes(inputValue);
    });
    return getCategoriesNgos(filteredValues, handleShowDetailNgo, environmentConfig, selected)
  };

export {getSearchedNGOs};